module.exports = {"130723100":"康保镇","130723101":"张纪镇","130723102":"土城子镇","130723103":"邓油坊镇","130723104":"李家地镇","130723105":"照阳河镇","130723106":"屯垦镇","130723200":"闫油坊乡","130723201":"丹清河乡","130723202":"哈咇嘎乡","130723203":"二号卜乡","130723204":"芦家营乡","130723205":"忠义乡","130723206":"处长地乡","130723207":"满德堂乡","130723500":"康保牧场","130723501":"屯垦林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130723.json
// module id = 186
// module chunks = 0